<template>
    <div class="textarea-box">
        <div class="text-textarea">
            <TextEditor
                :placeholder="placeholder"
                class="textarea"
                tag="span"
                ref="textInput"
                maxlength="2000"
                @input="inputChange"
                @selectedText="selectedHandle"
                @clickLinkWord="clickLinkWord"
                @clickLinkQuestion="clickLinkQuestion"
                @clickLinkHigh="clickLinkHigh"
                :bgColor="colorData.bubble"
                :baseColor="colorData.text"
                :dataValue="initInputValue"
                :cmdParam="data.cmd"
                :cmdTagParam="data.cmdTagClassify"
            />
        </div>
        <TextOperateBar @showEmoji="showEmoji" :disabled="computedStatus" :hiddenBtns="hiddenBtns" :data="colorData" @itemClick="itemClick" />
        <Emoji v-if="isShowEmoji" class="emoji" @emojiHandle="emojiHandle"></Emoji>
    </div>
</template>

<script>
import Emoji from "@/views/zhiji/bComponents/emoji/Emoji";
import TextEditor from "./textItem/TextEditor";
import TextOperateBar from "./textItem/TextOperateBar";
import LinkWordModal from "../../modals/LinkWordModal";
import LinkQuestionModal from "../../modals/LinkQuestionModal";
import AddPortraitEdit from "../AddPortraitEdit";
import i18n from "@/i18n";
import Vue from "vue";
Vue.component("AddPortraitEdit", AddPortraitEdit);

export default {
    name: "TextLinkContent",
    props: ["data", "placeholder", "hiddenBtns"],
    components: {
        Emoji,
        TextEditor,
        TextOperateBar
    },
    data() {
        return {
            isShowEmoji: false,
            selectTxt: "",
            highWordId: ""
        };
    },
    computed: {
        hiLinkLabel() {
            return this.$t("zhiji.answer.textWidget.textLink");
        },
        initInputValue() {
            return this.getHtmlByObject(this.data);
        },
        colorData() {
            // 获取组件设置颜色
            return this.getStorePorp("widgetsColor");
        },
        computedStatus() {
            if (this.selectTxt && this.data.text != "") {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        showEmoji() {
            this.isShowEmoji = !this.isShowEmoji;
        },
        inputChange(data) {
            this.$emit("inputChange", data);
        },
        emojiHandle(data) {
            let imgCode = data.imgCode;
            this.$refs.textInput.addEmoji(imgCode);
            this.isShowEmoji = false;
        },
        handleDocumentClick(e) {
            if (!this.$el.contains(e.target)) {
                this.isShowEmoji = false;
            }
        },
        clickLinkWord(data) {
            data.type = "update";
            this.showLinkModal(data, data.url);
        },
        clickLinkQuestion(data) {
            this.linkQuestionHandle(data);
        },
        clickLinkHigh(data) {
            this.highWordId = data.id;
        },
        selectedHandle(data) {
            this.selectTxt = data;
        },
        itemClick(data) {
            if (JSON.stringify(this.colorData) == "{}") {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.answer.textWidget.setColorTip")
                    }
                });
                return;
            }
            const handlers = {
                highlightWord: this.hiWordHandle,
                linkQuestion: this.linkQuestion,
                linkWord: this.newLinkWord,
                addPortrait: this.addPortrait // 添加用户画像
            };

            handlers[data.type].call(null, data.event);
        },
        addPortrait(data) {
            if (!this.$refs.textInput.savedRange) {
                this.$notify({
                    title: this.$t("zhiji.portrait.warm"),
                    message: this.$t("zhiji.portrait.positionTips"),
                    type: "warning"
                });
                return;
            }
            // 获取当前位置
            const element = data.target.getBoundingClientRect();
            const left = `${element.left}px`;
            const top = `${element.top + element.height + 5}px`;
            const self = this;
            this.$store.dispatch("zhiji/showModal", {
                type: "AddPortraitEdit",
                data: {
                    position: {
                        left,
                        top
                    },
                    callback(res) {
                        self.$refs.textInput.addPortrait(res);
                    }
                }
            });
        },
        hiWordHandle() {
            this.highWordId ? this.updateHighWord() : this.addHighWord();
            this.selectTxt = "";
            this.highWordId = "";
        },
        addHighWord() {
            this.selectTxt &&
                this.$refs.textInput.addHihtColor({
                    word: this.selectTxt,
                    color: this.colorData.highlight
                });
        },
        updateHighWord() {
            this.selectTxt &&
                this.$refs.textInput.updateHihtColor({
                    id: this.highWordId,
                    word: this.selectTxt,
                    color: this.colorData.highlight
                });
        },
        linkQuestion() {
            this.linkQuestionHandle();
        },
        linkQuestionHandle(word) {
            (this.selectTxt || (word && word.text)) &&
                this.$store.dispatch("zhiji/showModal", {
                    type: LinkQuestionModal,
                    data: {
                        id: word && word.id,
                        word: word ? word.text : this.selectTxt,
                        wordColor: "#bf600c", // TODO 暂时写死颜色
                        question: (word && word.question) || "",
                        confirm: question => {
                            if (question.type == "add") {
                                this.$refs.textInput.addQuestion(question);
                            } else if (question.type == "update") {
                                this.$refs.textInput.updateQuestion(question);
                            } else if (question.type == "delete") {
                                this.$refs.textInput.deleteLink(question);
                            }
                            this.selectTxt = "";
                        },
                        cancel: () => {
                            this.selectTxt = "";
                        }
                    }
                });
        },
        newLinkWord() {
            this.showLinkModal({
                type: "add"
            });
        },
        showLinkModal(word, url) {
            (this.selectTxt || word.text) &&
                this.$store.dispatch("zhiji/showModal", {
                    type: LinkWordModal,
                    data: {
                        type: word.type,
                        id: word && word.id,
                        word: this.selectTxt || word.text,
                        url: url || "",
                        text: this.data.text,
                        colorType: (word && word.colorType) || "innerColor",
                        colorData: {
                            outColor: this.colorData.outerLink,
                            innerColor: this.colorData.innerLink
                        },
                        confirm: link => {
                            if (link.type == "add") {
                                this.$refs.textInput.addLink(link);
                            } else if (link.type == "update") {
                                this.$refs.textInput.updateLink(link);
                            } else {
                                this.$refs.textInput.deleteLink(link);
                            }
                            this.selectTxt = "";
                        },
                        cancel: () => {
                            this.selectTxt = "";
                        }
                    }
                });
        },
        getHtmlByObject(obj) {
            if (!obj) return "";
            let html = obj.text;
            let colorData = this.colorData;
            obj.linkWord.forEach(item => {
                let htmlTemplate = "";
                if (item.type == "highlight") {
                    htmlTemplate = `<p style="color: ${colorData.highlight}" type="${item.type}" id="${item.id}">${item.word}</p>`;
                } else if (item.linkType == "custom_page") {
                    htmlTemplate = `<span style="color: ${colorData.innerLink}" id="${item.id}" type="link" data-url="${item.url}" data-type="innerColor">${item.word}</span>`;
                } else if (item.linkType == "new_page") {
                    htmlTemplate = `<span style="color: ${colorData.outerLink}" id="${item.id}" type="link" data-url="${item.url}" data-type="outColor">${item.word}</span>`;
                } else if (item.type == "question") {
                    // TODO 颜色暂时写死
                    htmlTemplate = `<span style="color: #bf600c" id="${item.id}" type="${item.type}" data-question="${item.question}" data-questionId="${item.questionId}">${item.word}</span>`;
                }
                html = html.replace(`{{${item.id}}}`, htmlTemplate);
            });
            return html.replace(/\n/g, "<br/>");
        }
    },
    mounted() {
        document.addEventListener("click", this.handleDocumentClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.handleDocumentClick);
    }
};
</script>

<style lang="scss" scoped>
.text-textarea {
    position: relative;
    background: #fafbfd;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    & > .textarea {
        padding: 10px 10px 24px;
        height: 191px;
        background: transparent;
        vertical-align: top;
    }
}

.text-textarea-bot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    height: 33px;
    border-radius: 0 0 4px 4px;
    background: #d9e4ef;
}

.text-face {
    width: 20px;
    height: 20px;
    cursor: pointer;
    background: url($zhijiStaticImagePath+"class-spr.png") -297px -21px;
}

.text-opt-link {
    font-size: 14px;
    height: 25px;
    line-height: 23px;
    background: #fff;
    border-radius: 4px;
    padding: 0 8px;
    cursor: pointer;

    &:before {
        display: inline-block;
        content: "";
        width: 15px;
        height: 15px;
        vertical-align: -3px;
        margin-right: 4px;
        background: url($zhijiStaticImagePath+"class-spr.png") -322px 0;
    }

    .text-link-count {
        color: #2ec2ff;
        margin-left: 3px;
        display: inline-block;
        background: #d9e4ef;
        padding: 0 4px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
    }
}

.text-word-popup {
    left: auto !important;
    right: 0;
    transform: translateX(100%);
}

.emoji {
    position: absolute;
    bottom: -200px;
    left: 0;
    z-index: 1;
}
.text-preview {
    margin-left: 12px;
}
</style>
